var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("p", { staticStyle: { padding: "36px 0 8px 0" } }, [
      _vm._v(
        "学科网（北京）股份有限公司 @2007-" +
          _vm._s(new Date().getFullYear()) +
          "学科网版权所有 题库自主建设 京ICP备12013499号-24"
      )
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("举报电话：400-102-2000 举报邮箱：jubao@xkw.cn ")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f906bf10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f906bf10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = null
// module chunks = 